import React from 'react';
import { RegisterForm } from '../components/RegisterForm';

export const Register = () => {
    return <RegisterForm />;
};
